import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Splash.css";
import Logo from "../../assets/logos/LogoColurs.png";
import { AuthContext } from '../../context/AuthContext';
import { UtilContext } from "../../context/UtilContext";

export const Splash = () => {
    const [progress, setProgress] = useState(0);
    const [step, setStep] = useState(null);
    const [StepData, setStepData] = useState(null);

    const [dataOnboarding, setDataOboarding] = useState(null);

    const navigate = useNavigate();
    const { getAuthenticatedHeaders, setStatusDocument, StatusDocument, setPerson, DetailUser, setDetailUser, } = useContext(AuthContext);
    const { setLanguage, } = useContext(UtilContext);

    const speedMultiplier = useRef(1);
    const animateProgress = (target) => {
        if (progress < target) {
            setProgress((prev) => Math.min(prev + speedMultiplier.current, target));

            setTimeout(() => requestAnimationFrame(() => animateProgress(target)), 20);
        }
    };

    const onServiceResponse = () => {
        speedMultiplier.current = 5;
    };
    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                // Llama al servicio con los headers autenticados
                const response = await axios.post(`/api/user`, {
                    headers: await getAuthenticatedHeaders(),
                });

                // Validar si la respuesta contiene datos válidos antes de guardarlos
                if (response?.data?.data && typeof response.data.data === "object") {
                    localStorage.setItem('userDetails', JSON.stringify(response.data.data));
                    setDetailUser(response.data.data);

                    console.log("response.data.data.country_company_incorporation", response.data.data.country_company_incorporation);

                    setLanguage(response.data.data.country_company_incorporation === "US" ? "en" : "es");

                    setPerson(response.data.data.type_person);

                    if (response.data.data.type_person === 2) {
                        setDataOboarding(response.data?.data?.onboarding);

                        if (response?.data?.data?.onboarding?.documents_level !== "APPROVED") {
                            setStatusDocument(response?.data?.data?.onboarding?.documents_level);
                        }

                        localStorage.removeItem("paso");

                        // Validación segura de steps
                        const stepMap = {
                            "ONE": 1, "TWO": 2, "THREE": 3, "FOUR": 4,
                            "FIVE": 5, "SIX": 6, "SEVEN": 7
                        };

                        const step = stepMap[response.data.data.onboarding?.step] || null;

                        if (step !== null) {
                            setStep(step);
                        } else {
                            console.error("Paso desconocido:", response.data.data.onboarding?.step);
                        }

                        // Simulación de barra de progreso y respuesta del servicio
                        animateProgress(100);
                        onServiceResponse();
                    } else {
                        return navigate("/dashboard", { state: { DetailUser: response.data.data } });
                    }
                } else {
                    console.warn("La respuesta del servidor no tiene datos válidos.");
                }

            } catch (error) {
                console.error("Error al obtener los detalles del usuario:", error);
            }
        };


        fetchUserDetails();


    }, [navigate]);
    useEffect(() => {


        if (StatusDocument !== null && progress == 100) {



            if (StatusDocument == 'INITIAL') {

                return navigate("/bienvenido", { state: { DetailUser: DetailUser } });
            }

            else if (StatusDocument == 'COMPLETED' && dataOnboarding.kyc === true && dataOnboarding.kyc_shareholder === true) {
                return navigate("/documentacion-completa", { state: { DetailUser: DetailUser } });
            }
            else if (StatusDocument == 'COMPLETED' && (dataOnboarding.kyc === false || dataOnboarding.kyc_shareholder === false)) {

                return navigate("/documentacion-legal", { state: { DetailUser: DetailUser, data: StepData, step: step } });
            }

            else if (StatusDocument == 'REJECTED') {

                return navigate("/subida-documentos", { state: { DetailUser: DetailUser } });

            }
            else if (StatusDocument == 'APPROVED') {


                return navigate("/dashboard", { state: { DetailUser: DetailUser } });

            } else if (StatusDocument == 'PENDING') {

                return navigate("/documentacion-legal", { state: { DetailUser: DetailUser, data: StepData, step: step } });


            }

            return () => setProgress(0);
        }
        if (progress === 100) {
            setStatusDocument(dataOnboarding.documents_level)

        }

    }, [StatusDocument, progress])


    return (
        <div
            className="splash-overlay flex flex-col h-screen items-center justify-center"
            style={{ background: '#1a1b22' }}
        >
            <img src={Logo} style={{ width: 64, height: 64, marginBottom: 40 }} alt="Logo" />
            <div className="progress-container">
                <div className="progress-bar" style={{ width: `${progress}%` }}></div>
            </div>
        </div>
    );
};

export default Splash;
